import { FC, useEffect, useRef } from 'react';

type SnippetProps = {
  clientId: string;
};

// Function to create a snippet component
// Function to create a snippet component
// Use effect to run code when the component mounts
const SnippetComponent: FC<SnippetProps> = ({ clientId }) => {
  const scriptAdded = useRef(false);

  useEffect(() => {
    if (!clientId || scriptAdded.current) return;

    let env: string | undefined = 'dev';
    let scriptUrl = 'https://snippet.cacxi.com.au/cacxi-script.js';

    switch (import.meta.env.VITE_AWS_ENV) {
      case 'prod':
        env = undefined;
        scriptUrl = 'https://snippet.cacxi.com.au/cacxi-script.js';
        break;
      case 'demo':
        env = 'stage';
        scriptUrl = 'https://snippet.demo.cacxi.com/cacxi-script.js';
        break;
      default:
        env = undefined;
        scriptUrl = 'https://snippet.cacxi.com.au/cacxi-script.js';
        break;
    }

    // Check if a script with the same src already exists
    if (document.querySelector(`script[src="${scriptUrl}"]`)) {
      scriptAdded.current = true;
      return;
    }

    const script = document.createElement('script');
    script.src = scriptUrl;
    script.defer = true;
    script.setAttribute('cacxi-id', clientId);
    if (env) {
      script.setAttribute('env', env);
    }

    // When script loads, trigger your initialization function
    script.onload = () => {
      if ((window as any).initCacxiSnippet) {
        (window as any).initCacxiSnippet();
      }
    };

    document.body.appendChild(script);
    scriptAdded.current = true;

    // Optionally, if you don't want to remove the script on unmount, omit the cleanup:
    // return () => document.body.removeChild(script);
  }, [clientId]);

  return null;
};

export default SnippetComponent;
